"use client";

import { useState, useEffect } from "react";
import { X } from "lucide-react";

interface PhotoThumbnailProps {
  /** Blob de la photo */
  blob: Blob;
  /** Nom du fichier (affiché en title) */
  fileName: string;
  /** Callback suppression */
  onDelete: () => void;
  /** Callback tap sur la photo (ouvre l'éditeur) */
  onTap: () => void;
}

/**
 * PhotoThumbnail — Miniature de photo avec bouton supprimer.
 * Tap = ouvrir l'éditeur crop. X = supprimer.
 */
export function PhotoThumbnail({ blob, fileName, onDelete, onTap }: PhotoThumbnailProps) {
  const [url, setUrl] = useState<string>("");

  useEffect(() => {
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  return (
    <div className="relative shrink-0 snap-start">
      <button
        type="button"
        onClick={onTap}
        className="block overflow-hidden rounded-md border border-border bg-muted"
        title={fileName}
      >
        {url && (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            src={url}
            alt={fileName}
            className="h-20 w-20 object-cover"
          />
        )}
      </button>

      {/* Bouton supprimer */}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
        className="absolute -top-1.5 -right-1.5 flex size-6 items-center justify-center rounded-full bg-destructive text-destructive-foreground shadow-sm"
        title="Supprimer"
      >
        <X className="size-3.5" />
      </button>
    </div>
  );
}
